


/* ===== MOOD QUIZ + LEAD GATE ===== */
var QZ=[
 {q:"When do you feel most yourself?",o:[["At sunrise, fresh start","sunflare"],["Bright midday energy","aqualume"],["Golden evening calm","woodveil"],["Late night, lights low","amorven"]]},
 {q:"Pick your escape:",o:[["A sunlit terrace","sunflare"],["The open ocean","aqualume"],["A blooming garden","floranta"],["A forest cabin","woodveil"]]},
 {q:"At a party, you are\u2026",o:[["The energy of the room","sunflare"],["Cool and easygoing","aqualume"],["Soft-spoken charm","floranta"],["The mystery in the corner","dusktime"]]},
 {q:"Choose a feeling:",o:[["A clean reset","aqualume"],["Quiet confidence","woodveil"],["Romance","amorven"],["Slow, unhurried hours","dusktime"]]}
];
var MOODS={sunflare:["Sunflare","Bright, clean and quietly uplifting — sunlight you can wear.","/#sunflare"],
 aqualume:["Aqualume","Clean skin, fresh mood — crisp as a just-pressed shirt.","/#aqualume"],
 floranta:["Floranta","Florals that don't pick a side — soft, easy elegance.","/#floranta"],
 woodveil:["Woodveil","Soft woods for quiet people — warm and grounded.","/#woodveil"],
 amorven:["Amorven","Romance for both — smooth, sensual, shared.","/#amorven"],
 dusktime:["Dusktime","Evening without labels — made for slow hours.","/#dusktime"]};
var qi=0,score={},claimed={};
function quizStart(){qi=0;score={};document.getElementById('quizRes').style.display='none';document.getElementById('quizPlay').style.display='block';quizRender();}
function quizRender(){
 var prog=document.getElementById('quizProg');prog.innerHTML='';
 for(var i=0;i<QZ.length;i++){var b=document.createElement('i');if(i<=qi)b.className='on';prog.appendChild(b);}
 document.getElementById('quizQ').textContent=QZ[qi].q;
 var box=document.getElementById('quizOpts');box.innerHTML='';
 QZ[qi].o.forEach(function(o){var b=document.createElement('button');b.textContent=o[0];
   b.onclick=function(){score[o[1]]=(score[o[1]]||0)+1;qi++;qi<QZ.length?quizRender():quizDone();};box.appendChild(b);});
}
function quizDone(){
 var best='sunflare',bv=-1;Object.keys(score).forEach(function(k){if(score[k]>bv){bv=score[k];best=k;}});
 var m=MOODS[best];
 document.getElementById('quizPlay').style.display='none';
 document.getElementById('quizRes').style.display='block';
 document.getElementById('quizName').textContent=m[0];
 document.getElementById('quizDesc').textContent=m[1];
 document.getElementById('quizLink').setAttribute('href',m[2]);
 document.getElementById('leadForm').style.display='grid';
 document.getElementById('couponWrap').style.display='none';
}
function leadSubmit(){
 var em=document.getElementById('leadEmail').value.trim().toLowerCase(),
     ph=document.getElementById('leadPhone').value.replace(/\D/g,'');
 if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em)){alert('Please enter a valid email.');return;}
 if(!/^[6-9]\d{9}$/.test(ph)){alert('Please enter a valid 10-digit Indian mobile number.');return;}
 var key=em+'|'+ph;
 if(claimed[key]){alert('This contact has already claimed a code — check your inbox!');return;}
 claimed[key]=1;
 /* DEV NOTE: POST lead to Klaviyo/Shopify here; generate unique one-time code; send via email/WhatsApp */
 document.getElementById('leadForm').style.display='none';
 document.getElementById('couponWrap').style.display='block';
}
var _qc=document.getElementById('quizCoupon');
if(_qc)_qc.onclick=function(){
 navigator.clipboard&&navigator.clipboard.writeText('MOOD10');
 this.querySelector('small').textContent='Copied! Use at checkout';
};
if(document.getElementById('quizRes'))quizStart();

/* ===== ATELIER + CERTIFICATE ===== */
document.querySelectorAll('.chips').forEach(function(g){
 g.querySelectorAll('button').forEach(function(b){
  b.onclick=function(){
   var sel=g.querySelectorAll('.sel');
   if(b.classList.contains('sel')){b.classList.remove('sel');return;}
   if(sel.length>=2){sel[0].classList.remove('sel');}
   b.classList.add('sel');
  };
 });
});
function makeCert(){
 var picks={top:[],heart:[],base:[]};
 document.querySelectorAll('.chips').forEach(function(g){
  g.querySelectorAll('.sel').forEach(function(b){picks[g.dataset.layer].push(b.textContent);});
 });
 var layers=['top','heart','base'].filter(function(k){return picks[k].length;}).length;
 if(!layers){alert('Pick at least one note to blend.');return;}
 var tier=layers===3?'Master Perfumer':layers===2?'Senior Perfumer':'Junior Perfumer';
 var blend=document.getElementById('blendName').value.trim()||'Untitled Blend';
 var name=document.getElementById('perfumerName').value.trim()||'A Keiiarra Perfumer';
 var c=document.getElementById('certCanvas'),x=c.getContext('2d');
 x.fillStyle='#FBF5E8';x.fillRect(0,0,1200,900);
 x.strokeStyle='#E9B949';x.lineWidth=6;x.strokeRect(40,40,1120,820);
 x.lineWidth=1.5;x.strokeRect(56,56,1088,788);
 x.fillStyle='#2B0E12';x.textAlign='center';
 x.font='600 34px Archivo, sans-serif';
 x.fillText('K E I I A R R A   A T E L I E R',600,150);
 x.font='italic 26px Newsreader, Georgia, serif';
 x.fillStyle='#A3242B';x.fillText('Certificate of Perfumery',600,200);
 x.fillStyle='#2B0E12';x.font='300 30px Archivo, sans-serif';
 x.fillText('This certifies that',600,290);
 x.font='500 72px Fraunces, Georgia, serif';x.fillText(name,600,380);
 x.font='300 28px Archivo, sans-serif';x.fillText('has composed the original blend',600,440);
 x.font='italic 54px Newsreader, Georgia, serif';x.fillStyle='#A3242B';
 x.fillText('\u201C'+blend+'\u201D',600,520);
 x.fillStyle='#2B0E12';x.font='300 24px Archivo, sans-serif';
 var notes=[].concat(picks.top,picks.heart,picks.base).join('  ·  ');
 x.fillText(notes,600,580);
 x.font='600 40px Fraunces, Georgia, serif';x.fillStyle='#9C7714';
 x.fillText(tier.toUpperCase(),600,680);
 x.font='300 22px Archivo, sans-serif';x.fillStyle='#2B0E12';
 var d=new Date();x.fillText('Awarded '+d.toLocaleDateString('en-IN',{day:'numeric',month:'long',year:'numeric'})+'  ·  keiiarra.com',600,780);
 document.getElementById('certDl').disabled=false;
}
function dlCert(){
 var a=document.createElement('a');a.download='keiiarra-perfumer-certificate.png';
 a.href=document.getElementById('certCanvas').toDataURL('image/png');a.click();
}

/* ===== CART (drawer + drop animation with real bottles) ===== */
var BOTTLES={"sunflare": "//keiiarra.com/cdn/shop/t/50/assets/kei-e198fa25.png?v=173228703203973997561789141528", "aqualume": "//keiiarra.com/cdn/shop/t/50/assets/kei-a656152d.png?v=129108383263698743501789141528", "floranta": "//keiiarra.com/cdn/shop/t/50/assets/kei-4d4a384a.png?v=141898840564062038611789141528", "woodveil": "//keiiarra.com/cdn/shop/t/50/assets/kei-895c97af.png?v=93775872621905825751789141528", "amorven": "//keiiarra.com/cdn/shop/t/50/assets/kei-ab411c3a.png?v=17351228050714216501789141528", "dusktime": "//keiiarra.com/cdn/shop/t/50/assets/kei-71331cb5.png?v=111255822447119312101789141528"};
var PRODUCT_NAMES={sunflare:'Sunflare',aqualume:'Aqualume',floranta:'Floranta',woodveil:'Woodveil',amorven:'Amorven',dusktime:'Dusktime'};
var CART={};
function cartCountTotal(){var n=0;Object.keys(CART).forEach(function(k){n+=CART[k].qty;});return n;}

/* ===== PERFUME FLOATING CART + PERSONAL INSIGHTS ===== */
var MOOD_OF={sunflare:'morning light',aqualume:'a clear head',floranta:'easy afternoons',woodveil:'quiet evenings',amorven:'someone close',dusktime:'slow nights','set-twilight':'three evening moods','set-radiant':'three daylight moods','trial-kit':'all six moods'};
function fabInsight(lastId){
 var qty=cartCountTotal();
 var ids=Object.keys(CART);
 var msg;
 if(qty===1){
  var m=MOOD_OF[lastId]||'your mood';
  msg='A scent for <b>'+m+'</b> is in your bag.';
 }else if(ids.length===1){
  msg='You really felt this one. <b>'+CART[ids[0]].qty+'</b> on the way \u2728';
 }else if(ids.length>=3){
  msg='<b>'+ids.length+' moods</b> chosen \u2014 that\u2019s a whole day of you.';
 }else{
  var total=0;ids.forEach(function(k){total+=CART[k].price*CART[k].qty;});
  if(total<300){msg='Add the \u20B999 Try Kit \u2014 find your <b>next</b> mood.';}
  else{msg='<b>Free shipping</b> already yours \u00B7 tap to checkout.';}
 }
 var el=document.getElementById('fabInsight');
 el.innerHTML=msg;el.classList.add('show');
 clearTimeout(el._t);el._t=setTimeout(function(){el.classList.remove('show');},4200);
}
function updateFab(lastId){
 var qty=cartCountTotal();
 var fab=document.getElementById('fabCart'),cnt=document.getElementById('fabCount');
 if(qty>0){fab.classList.add('show');}
 cnt.textContent=qty;cnt.style.display=qty>0?'flex':'none';
 fab.classList.remove('bump');void fab.offsetWidth;fab.classList.add('bump');
 if(lastId)fabInsight(lastId);
}

function renderCart(){
 var items=document.getElementById('cdItems'),empty=document.getElementById('cdEmpty'),foot=document.getElementById('cdFoot');
 items.innerHTML='';var keys=Object.keys(CART),total=0;
 keys.forEach(function(k,idx){
  var it=CART[k];total+=it.price*it.qty;
  var row=document.createElement('div');row.className='ci';row.style.animationDelay=(idx*60)+'ms';
  row.style.setProperty('--ctint',it.tint);
  row.innerHTML='<span class="dot"></span><span class="nm">'+it.name+'<small>'+(k.indexOf('set-')===0?'3 \u00D7 18ml set':'18ml · eau de parfum')+'</small></span>'+
   '<span class="qtyc"><button aria-label="less" onclick="chQty(\''+k+'\',-1)">\u2212</button><b>'+it.qty+'</b><button aria-label="more" onclick="chQty(\''+k+'\',1)">+</button></span>'+
   '<span class="pr">\u20B9'+(it.price*it.qty)+'</span>';
  items.appendChild(row);
 });
 var has=keys.length>0;
 empty.style.display=has?'none':'flex';items.style.display=has?'block':'none';foot.style.display=has?'block':'none';
 document.getElementById('cdTotal').textContent='\u20B9'+total;
 document.getElementById('cartCount').textContent=cartCountTotal();
}
function chQty(k,d){
 CART[k].qty+=d;if(CART[k].qty<=0)delete CART[k];
 renderCart();
 if(typeof updateFab==='function')updateFab();
 var btn=document.querySelector('[data-cartbtn="'+k+'"]');
 if(btn){var q=CART[k]?CART[k].qty:0;var lbl=btn.querySelector('.lbl'),bd=btn.querySelector('.qty-badge');
  if(q>0){lbl.textContent='In cart · '+q;bd.textContent=q;bd.classList.add('show');}
  else{lbl.textContent=btn.dataset.orig;bd.classList.remove('show');}}
}
function openCart(){document.getElementById('cartDrawer').classList.add('open');document.getElementById('cartOverlay').classList.add('open');renderCart();}
function closeCart(){document.getElementById('cartDrawer').classList.remove('open');document.getElementById('cartOverlay').classList.remove('open');}
var _cl=document.querySelector('.cart-link');if(_cl)_cl.addEventListener('click',function(e){e.preventDefault();openCart();});

function addToCart(id,name,price,tint){
 if(!CART[id])CART[id]={name:name,price:price,qty:0,tint:tint};
 CART[id].qty++;renderCart();
 updateFab(id);
 if(id==='trial-kit'){
  /* DEMO: in production the chip shows for logged-in customers tagged tryit-buyer */
  document.getElementById('floatCoupon').classList.add('show');
  toast('✨ TRYIT10 unlocked — it stays with your account');
 }
}
function copyTry(){
 navigator.clipboard&&navigator.clipboard.writeText('TRYIT10');
 toast('TRYIT10 copied · 10% off, max ₹100');
}
function attachDrop(btn,info){
 var label=document.createElement('span');label.className='lbl';label.textContent=btn.textContent.trim();
 btn.dataset.orig=btn.textContent.trim();btn.dataset.cartbtn=info.id;
 btn.textContent='';btn.appendChild(label);
 var badge=document.createElement('span');badge.className='qty-badge';btn.appendChild(badge);
 btn.addEventListener('click',function(e){
  e.preventDefault();
  if(btn.dataset.busy)return;btn.dataset.busy=1;
  var br=btn.getBoundingClientRect();
  var DROP=Math.min(260,br.top+70);
  var fly=document.createElement('div');fly.className='fly';
  if(BOTTLES[info.id]){fly.innerHTML='<img src="'+BOTTLES[info.id]+'" alt="">';}
  else{fly.innerHTML='<svg width="30" height="64" viewBox="0 0 50 78"><path d="M17 2 h16 a4 4 0 0 1 4 4 v9 h-24 v-9 a4 4 0 0 1 4 -4 z" fill="#8a6d22"/><rect x="18" y="15" width="14" height="5" fill="#caa23f"/><rect x="9" y="20" width="32" height="56" rx="8" fill="'+info.tint+'"/><circle cx="25" cy="46" r="7" fill="none" stroke="#FBF5E8" stroke-width="1.6" opacity=".85"/></svg>';}
  fly.style.left=(br.left+br.width/2-20)+'px';
  fly.style.top=(br.top-DROP-74)+'px';
  document.body.appendChild(fly);
  fly.animate([
   {transform:'translateY(0) scale(.65) rotate(-8deg)',opacity:0},
   {transform:'translateY('+Math.round(DROP*.35)+'px) scale(.9) rotate(-3deg)',opacity:1,offset:.3},
   {transform:'translateY('+DROP+'px) scale(1) rotate(0deg)',offset:.72,easing:'cubic-bezier(.4,0,.9,.6)'},
   {transform:'translateY('+(DROP+10)+'px) scaleX(1.18) scaleY(.78)',offset:.84},
   {transform:'translateY('+(DROP+2)+'px) scale(.92)',offset:.92},
   {transform:'translateY('+(DROP+8)+'px) scale(.22)',opacity:0}
  ],{duration:720,easing:'cubic-bezier(.3,0,.5,1)'}).onfinish=function(){
   fly.remove();delete btn.dataset.busy;
   btn.animate([{transform:'translateY(0) scale(1)'},{transform:'translateY(4px) scale(.96)'},{transform:'translateY(0) scale(1)'}],{duration:280,easing:'ease-out'});
   var ring=document.createElement('span');ring.className='impact-ring';ring.style.borderColor=info.tint;
   btn.appendChild(ring);setTimeout(function(){ring.remove();},600);
   addToCart(info.id,info.name,info.price,info.tint);
   var q=CART[info.id].qty;
   label.textContent='In cart · '+q;
   badge.textContent=q;badge.classList.add('show');
   badge.classList.remove('pop');void badge.offsetWidth;badge.classList.add('pop');
   btn.classList.add('added');setTimeout(function(){btn.classList.remove('added');},900);
   var cl=document.querySelector('.cart-link');cl.classList.remove('bump');void cl.offsetWidth;cl.classList.add('bump');
  };
 });
}
document.querySelectorAll('.add-cart').forEach(function(btn){
 var art=btn.closest('.mood');if(!art)return;var id=art.id;
 var tint=getComputedStyle(art).getPropertyValue('--tint').trim()||'#E9B949';
 attachDrop(btn,{id:id,name:PRODUCT_NAMES[id],price:220,tint:tint});
});
document.querySelectorAll('.add-set').forEach(function(btn){
 attachDrop(btn,{id:btn.dataset.id,name:btn.dataset.name,price:parseInt(btn.dataset.price,10),tint:btn.dataset.tint});
});

/* ===== SMOOTH ANCHORS (fixes in-page links in any viewer) ===== */
document.querySelectorAll('a[href^="#"]').forEach(function(a){
 a.addEventListener('click',function(e){
  var t=document.querySelector(a.getAttribute('href'));
  if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth',block:'start'});}
 });
});


/* ===== NAV DRAWER + ACCOUNT SHEET (demo UI; Shopify-powered at build) ===== */
function toggleNav(){
 var d=document.getElementById('navDrawer'),b=document.getElementById('menuBtn'),o=document.getElementById('navOverlay');
 var open=!d.classList.contains('open');
 d.classList.toggle('open',open);b.classList.toggle('open',open);o.classList.toggle('open',open);
 b.setAttribute('aria-expanded',open);
 if(!open)closeAcct();
}
function closeNav(){
 document.getElementById('navDrawer').classList.remove('open');
 document.getElementById('menuBtn').classList.remove('open');
 document.getElementById('menuBtn').setAttribute('aria-expanded','false');
 if(!document.getElementById('acctSheet').classList.contains('open'))
  document.getElementById('navOverlay').classList.remove('open');
}
function openAcct(){
 document.getElementById('acctSheet').classList.add('open');
 document.getElementById('navOverlay').classList.add('open');
 document.getElementById('navDrawer').classList.remove('open');
 document.getElementById('menuBtn').classList.remove('open');
}
function closeAcct(){
 document.getElementById('acctSheet').classList.remove('open');
 document.getElementById('navOverlay').classList.remove('open');
}
function acctTab(t){
 document.getElementById('tabEmail').classList.toggle('on',t==='email');
 document.getElementById('tabPhone').classList.toggle('on',t==='phone');
 document.getElementById('paneEmail').style.display=t==='email'?'block':'none';
 document.getElementById('panePhone').style.display=t==='phone'?'block':'none';
 document.getElementById('otpRow').classList.remove('show');
 document.getElementById('acctGo').textContent='Send code';
}
function chan(b){
 b.parentNode.querySelectorAll('button').forEach(function(x){x.classList.remove('on');});
 b.classList.add('on');
}
function acctSend(){
 var go=document.getElementById('acctGo'),row=document.getElementById('otpRow');
 if(!row.classList.contains('show')){
  row.classList.add('show');go.textContent='Verify & continue';
  row.querySelector('input').focus();
  toast('Code sent \u00B7 demo preview');
 }else{
  toast('Demo \u2014 connects to Shopify accounts at build \u2713');
  closeAcct();
 }
}
function toast(msg){
 var t=document.getElementById('toast');t.textContent=msg;
 t.classList.remove('show');void t.offsetWidth;t.classList.add('show');
 setTimeout(function(){t.classList.remove('show');},2200);
}
/* OTP boxes auto-advance */
document.querySelectorAll('#otpRow input').forEach(function(inp,i,all){
 inp.addEventListener('input',function(){if(inp.value&&all[i+1])all[i+1].focus();});
 inp.addEventListener('keydown',function(e){if(e.key==='Backspace'&&!inp.value&&all[i-1])all[i-1].focus();});
});


/* ===== SCENT BUBBLES (one at a time, perfume-vapor style) ===== */
(function(){
 if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
 var _bc=document.querySelector('[data-kei-bubbles]');
 var BCFG=_bc?JSON.parse(_bc.textContent):{};
 if(BCFG.enabled===false)return;
 var LABELS=(BCFG.labels||[]).filter(function(x){return x&&String(x).trim();});
 if(!LABELS.length)LABELS=['\u20B999<br>Try 6','TRYIT10<br>10% off','\uD83C\uDF81<br>Try &amp; Buy'];
 var li=0;
 function uiBusy(){
  return document.querySelector('.cart-drawer.open,.nav-drawer.open,.acct-sheet.open');
 }
 function spawn(){
  if(document.hidden||uiBusy())return;
  if(document.querySelectorAll('.bubble').length>=2)return;
  var b=document.createElement('button');
  b.className='bubble';b.setAttribute('aria-label','Try It Kit offer');
  b.innerHTML=LABELS[li++%LABELS.length];
  b.style.left=(72+Math.random()*18)+'vw';
  b.style.setProperty('--dur',(8+Math.random()*3)+'s');
  b.onclick=function(e){
   e.preventDefault();
   b.classList.add('pop');
   var dest=BCFG.link||'/pages/try-it-buy-it';
   var t=(dest==='/pages/try-it-buy-it')?document.getElementById('tryit'):null;
   toast(BCFG.toast||'\uD83E\uDDEA Try all six \u00B7 \u20B999 \u00B7 refundable');
   if(t){t.scrollIntoView({behavior:'smooth',block:'start'});}
   else{setTimeout(function(){window.location.href=dest;},420);}
   setTimeout(function(){b.remove();},360);
  };
  b.addEventListener('animationend',function(e){if(e.animationName==='rise')b.remove();});
  if(!b.textContent.trim())b.innerHTML='\u20B999<br>Try 6';
  document.body.appendChild(b);
  var durMs=(parseFloat(b.style.getPropertyValue('--dur'))||10)*1000;
  b.dataset.dieAt=Date.now()+durMs+600;
  setTimeout(function(){if(b.parentNode)b.remove();},durMs+600);
 }
 setTimeout(spawn,4000);
 setInterval(spawn,10000);
 setInterval(function(){document.querySelectorAll('.bubble').forEach(function(b){
  if(b.dataset.dieAt&&Date.now()>parseInt(b.dataset.dieAt,10))b.remove();
  var r=b.getBoundingClientRect();
  if(r.bottom<90)b.remove();
 });},2000);
})();
/* ===== alternating floating pill: Healing <-> Try It ===== */
(function(){
 var p=document.getElementById('floatSoon');if(!p)return;
 var states=[['\u2728 Healing \u00B7 Soon','/pages/healing-soon'],['\uD83E\uDDEA Try 6 \u00B7 \u20B999','/pages/try-it-buy-it']],s=0;
 setInterval(function(){
  s=1-s;p.style.opacity='0';
  setTimeout(function(){p.innerHTML=states[s][0];p.setAttribute('href',states[s][1]);p.style.opacity='1';},300);
 },6000);
})();


/* ===== SKU REEL ===== */
function playReel(btn){
 var url=btn.getAttribute('data-reel');
 if(!url){toast('Reel slot — add a vertical video/Instagram reel here 🎞️');return;}
 /* DEV: data-reel can be a self-hosted .mp4 or an embed URL.
    mp4 -> inject <video autoplay controls playsinline loop>; embed -> <iframe>. */
 var v=document.createElement('video');
 v.src=url;v.autoplay=true;v.controls=true;v.playsInline=true;v.loop=true;
 btn.innerHTML='';btn.appendChild(v);btn.onclick=null;
}
/* ===== GALLERY LIGHTBOX ===== */
function lightbox(el){
 var f=el.getAttribute('data-full');if(!f)return;
 document.getElementById('lbImg').src=f;
 document.getElementById('lightbox').classList.add('open');
}
/* ===== REFILL RHYTHM OPT-IN ===== */
function rfJoin(){
 var p=document.getElementById('rfPhone').value.replace(/\D/g,'');
 if(!/^[6-9]\d{9}$/.test(p)){toast('Valid 10-digit number please');return;}
 document.getElementById('rfPhone').value='';
 toast('\u2705 Refill reminder set \u00B7 demo \u2014 wires to Interakt at build');
}


/* ===== SKU REEL ===== */
function playReel(btn){
 var url=btn.getAttribute('data-reel');
 if(!url){toast('Reel slot — add a vertical video/Instagram reel here 🎞️');return;}
 /* DEV: data-reel can be a self-hosted .mp4 or an embed URL.
    mp4 -> inject <video autoplay controls playsinline loop>; embed -> <iframe>. */
 var v=document.createElement('video');
 v.src=url;v.autoplay=true;v.controls=true;v.playsInline=true;v.loop=true;
 btn.innerHTML='';btn.appendChild(v);btn.onclick=null;
}
/* ===== GALLERY LIGHTBOX ===== */
function lightbox(el){
 var f=el.getAttribute('data-full');if(!f)return;
 document.getElementById('lbImg').src=f;
 document.getElementById('lightbox').classList.add('open');
}
/* ===== HINGLISH TOGGLE (demo: key strings; full i18n via Shopify Translate & Adapt) ===== */
var LANG='en';
var I18N=[
 ['.announce','Free shipping across India \u00B7 18ml flight-friendly bottles \u00B7 Cruelty-free','\u092A\u0942\u0930\u0947 \u092D\u093E\u0930\u0924 \u092E\u0947\u0902 \u092E\u0941\u095E\u094D\u0924 \u0936\u093F\u092A\u093F\u0902\u0917 \u00B7 18ml \u092F\u093E\u0924\u094D\u0930\u093E-\u0905\u0928\u0941\u0915\u0942\u0932 \u092C\u094B\u0924\u0932\u0947\u0902 \u00B7 \u0915\u094D\u0930\u0942\u0090\u0932\u094D\u091F\u0940-\u092B\u094D\u0930\u0940'],
 ['.hero .eyebrow','Scents for your essence \u00B7 Blended in India \uD83C\uDDEE\uD83C\uDDF3','\u0906\u092A\u0915\u0940 \u092A\u0939\u091A\u093E\u0928 \u0915\u0947 \u0932\u093F\u090F \u0938\u0941\u0917\u0902\u0927 \u00B7 \u092D\u093E\u0930\u0924 \u092E\u0947\u0902 \u0928\u093F\u0930\u094D\u092E\u093F\u0924 \uD83C\uDDEE\uD83C\uDDF3'],
 ['.hero h1','A perfume for every <em>mood</em> of your day.','\u0906\u092A\u0915\u0947 \u0926\u093F\u0928 \u0915\u0947 \u0939\u0930 <em>\u092E\u0942\u0921</em> \u0915\u0947 \u0932\u093F\u090F \u090F\u0915 \u0907\u0924\u094D\u0930\u0964'],
 ['.hero .sub','Six long-lasting fragrances beyond gender \u2014 one for every mood, from the first light of morning to the slow hours of night. Crafted in India. Yours from \u20B9220.','\u091B\u0939 \u0932\u0902\u092C\u0947 \u0938\u092E\u092F \u0924\u0915 \u091F\u093F\u0915\u0928\u0947 \u0935\u093E\u0932\u0940 \u0938\u0941\u0917\u0902\u0927\u0947\u0902, \u091C\u0947\u0902\u0921\u0930 \u0938\u0947 \u092A\u0930\u0947 \u2014 \u0939\u0930 \u092E\u0942\u0921 \u0915\u0947 \u0932\u093F\u090F \u090F\u0915, \u0938\u0941\u092C\u0939 \u0915\u0940 \u092A\u0939\u0932\u0940 \u0915\u093F\u0930\u0923 \u0938\u0947 \u0930\u093E\u0924 \u0915\u0947 \u0938\u0941\u0915\u0942\u0928 \u0924\u0915\u0964 \u092D\u093E\u0930\u0924 \u092E\u0947\u0902 \u0928\u093F\u0930\u094D\u092E\u093F\u0924\u0964 \u0915\u0947\u0935\u0932 \u20B9220 \u0938\u0947\u0964'],
 ['.hero .ctas .btn-solid','Find your mood','\u0905\u092A\u0928\u093E \u092E\u0942\u0921 \u0922\u0942\u0902\u0922\u0947\u0902'],
 ['.hero-offer','<span class="dot"></span> New \u00B7 Try all six for \u20B999 \u2014 fully refundable','<span class="dot"></span> \u0928\u092F\u093E \u00B7 \u091B\u0939\u094B\u0902 \u0915\u094B \u20B999 \u092E\u0947\u0902 \u0906\u095B\u092E\u093E\u090F\u0902 \u2014 \u092A\u0942\u0930\u093E \u0930\u093F\u092B\u0902\u0921'],
 ['#moods .day-head .eyebrow','The Keiiarra Collection','\u0915\u0947\u0907\u0906\u0930\u093E \u0915\u0932\u0947\u0915\u094D\u0936\u0928'],
 ['#moods .day-head h2','One day. Six moods. Six scents.','\u090F\u0915 \u0926\u093F\u0928\u0964 \u091B\u0939 \u092E\u0942\u0921\u0964 \u091B\u0939 \u0938\u0941\u0917\u0902\u0927\u0947\u0902\u0964'],
 ['#tryit .eyebrow','Try It, Buy It \u00B7 Zero-risk first step','\u0906\u095B\u092E\u093E\u090F\u0902, \u092B\u093F\u0930 \u0916\u0930\u0940\u0926\u0947\u0902 \u00B7 \u092C\u093F\u0928\u093E \u0915\u093F\u0938\u0940 \u091C\u094B\u0916\u093F\u092E'],
 ['#collections .eyebrow','Curated sets','\u091A\u0941\u0928\u093F\u0902\u0926\u093E \u0938\u0947\u091F'],
 ['#memories .eyebrow','The Memory Wall \u00B7 Monthly contest','\u092E\u0947\u092E\u094B\u0930\u0940 \u0935\u0949\u0932 \u00B7 \u092E\u093E\u0938\u093F\u0915 \u092A\u094D\u0930\u0924\u093F\u092F\u094B\u0917\u093F\u0924\u093E'],
 ['#founder .display','Meet the Essencewali.','\u092E\u093F\u0932\u093F\u090F \u090F\u0938\u0947\u0902\u0938\u0935\u093E\u0932\u0940 \u0938\u0947\u0964'],
 ['.sb-top','Free shipping across India','\u092A\u0942\u0930\u0947 \u092D\u093E\u0930\u0924 \u092E\u0947\u0902 \u092E\u0941\u095E\u094D\u0924 \u0936\u093F\u092A\u093F\u0902\u0917'],
 ['.sb-sub','6 scents \u00B7 from \u20B9220','6 \u0938\u0941\u0917\u0902\u0927\u0947\u0902 \u00B7 \u20B9220 \u0938\u0947'],
 ['.sb-btn','Find your mood','\u092E\u0942\u0921 \u0922\u0942\u0902\u0922\u0947\u0902']
];

/* broad sweep dictionary: catches buttons, tags, headings not individually mapped */
var DICT={
 'Add to cart':'\u0915\u093E\u0930\u094D\u091F \u092E\u0947\u0902 \u0921\u093E\u0932\u0947\u0902',
 'Shop the set':'\u0938\u0947\u091F \u0916\u0930\u0940\u0926\u0947\u0902','Add set to cart':'\u0938\u0947\u091F \u0915\u093E\u0930\u094D\u091F \u092E\u0947\u0902 \u0921\u093E\u0932\u0947\u0902',
 'Try all six':'\u091B\u0939\u094B\u0902 \u0906\u095B\u092E\u093E\u090F\u0902','Find your mood':'\u092E\u0942\u0921 \u0922\u0942\u0902\u0922\u0947\u0902','Shop gift sets':'\u0917\u093F\u095E\u094D\u091F \u0938\u0947\u091F',
 'Post my memory':'\u092E\u0947\u0930\u0940 \u092F\u093E\u0926 \u092A\u094B\u0938\u094D\u091F \u0915\u0930\u0947\u0902','Notify me':'\u092E\u0941\u091D\u0947 \u0938\u0942\u091A\u093F\u0924 \u0915\u0930\u0947\u0902',
 'Our Story':'\u0939\u092E\u093E\u0930\u0940 \u0915\u0939\u093E\u0928\u0940','Gift Sets':'\u0917\u093F\u095E\u094D\u091F \u0938\u0947\u091F','The Six Moods':'\u091B\u0939 \u092E\u0942\u0921','Contact':'\u0938\u0902\u092A\u0930\u094D\u0915',
 'Longevity':'\u0938\u094D\u0925\u093E\u092F\u093F\u0924\u094D\u0935','Projection':'\u092A\u094D\u0930\u094B\u091C\u0947\u0915\u094D\u0936\u0928','Top':'\u091F\u0949\u092A','Heart':'\u0939\u093E\u0930\u094D\u091F','Base':'\u092C\u0947\u0938',
 'Why Keiiarra':'\u0915\u0947\u0907\u0906\u0930\u093E \u0915\u094D\u092F\u094B\u0902','The Founder':'\u0938\u0902\u0938\u094D\u0925\u093E\u092A\u0915','Replay':'\u092B\u093F\u0930 \u0938\u0947'
};
function sweepLang(toHi){
 if(!sweepLang.orig)sweepLang.orig=new WeakMap();
 var sel='.btn,.nav-links a,.nd-links a,.notes b,.meter span,.eyebrow,.tags span';
 document.querySelectorAll(sel).forEach(function(el){
  if(el.children.length>1)return;
  var t=el.textContent.trim();
  if(toHi){
   if(DICT[t]){if(!sweepLang.orig.has(el))sweepLang.orig.set(el,el.innerHTML);el.innerHTML=DICT[t];}
  }else if(sweepLang.orig.has(el)){el.innerHTML=sweepLang.orig.get(el);}
 });
}

function applyLang(){
 I18N.forEach(function(r){
  var el=document.querySelector(r[0]);
  if(!el)return;
  if(r[0]==='.sb-btn'){ /* keep the bottle icon inside the button */
   var svg=el.querySelector('svg');el.textContent='';if(svg)el.appendChild(svg);
   el.insertAdjacentText('beforeend',' '+(LANG==='en'?r[1]:r[2]));
  }else{
   el.innerHTML=LANG==='en'?r[1]:r[2];
  }
 });
 var sw=document.getElementById('langBtn');
 sw.classList.toggle('hi',LANG==='hi');
 var sp=sw.querySelectorAll('span');
 sp[0].classList.toggle('on',LANG==='en');
 sp[1].classList.toggle('on',LANG==='hi');
 document.documentElement.lang=(LANG==='hi'?'hi-IN':'en-IN');
}
function toggleLang(){
 LANG=LANG==='en'?'hi':'en';
 applyLang();
 sweepLang(LANG==='hi');
 toast(LANG==='hi'?'\u0939\u093F\u0902\u0926\u0940 \u092E\u0947\u0902 \u00B7 \u0921\u0947\u092E\u094B (\u092A\u0942\u0930\u0940 \u0938\u093E\u0907\u091F build \u092A\u0930)':'English');
}

/* ===== MEMORY WALL: moods, AI detect, counters ===== */
var EMOS={Love:'\u2764\uFE0F',Nostalgia:'\uD83D\uDD56',Joy:'\u2600\uFE0F',Calm:'\uD83C\uDF3F',Romance:'\uD83C\uDF39',Home:'\uD83C\uDFE0',Adventure:'\uD83C\uDF0A',Peace:'\uD83D\uDD4A\uFE0F'};
var COUNTS={Love:108,Nostalgia:91,Joy:67,Calm:54,Romance:49,Home:38,Adventure:21,Peace:29};
var selEmo='Nostalgia',byAI=true,manual=false;
var EMOKEYS={
 Love:['love','pyaar','pyar','jaan','dil','mohabbat','ishq','crush','propose','forever','hamesha','first love'],
 Romance:['roka','shaadi','shadi','wedding','date','kiss','gajra','honeymoon','valentine','candle','mehendi','sagai','partner','husband','wife','boyfriend','girlfriend','jasmine'],
 Nostalgia:['nani','dadi','dada','nana','childhood','school','college','old ','bachpan','yaad','memor','grandmother','grandfather','purani','purana','90s','cassette','vacation','hostel'],
 Home:['home','ghar','maa','mummy','mom','dad','papa','kitchen','family','balcony','terrace','gully','mohalla','rasoi','khana'],
 Joy:['laugh','hasna','smile','happy','khushi','diwali','holi','festival','dance','party','celebrat','birthday','jeet','won','win '],
 Calm:['rain','baarish','barish','monsoon','coffee','chai','evening','shaam','quiet','sukoon','peace ','slow','breeze','hawa','khidki','window','book'],
 Adventure:['beach','travel','trip','mountain','pahad','trek','goa','flight','road','sea','samundar','ocean','manali','ladakh','bike','safar','train'],
 Peace:['temple','mandir','prayer','pooja','puja','aarti','meditation','silence','diya','agarbatti','church','gurudwara','dargah','subah','morning']
};
function detectEmo(t){
 t=' '+t.toLowerCase()+' ';var best=null,bs=0;
 Object.keys(EMOKEYS).forEach(function(e){
  var s=0;EMOKEYS[e].forEach(function(k){if(t.indexOf(k)>-1)s++;});
  if(s>bs){bs=s;best=e;}
 });
 return bs>0?best:null;
}
function renderCounts(changed){
 var box=document.getElementById('moodCounts');box.innerHTML='';
 Object.keys(COUNTS).sort(function(a,b){return COUNTS[b]-COUNTS[a];}).forEach(function(e){
  var c=document.createElement('span');c.className='mc'+(e===changed?' pop':'');
  c.innerHTML=EMOS[e]+' '+e+'<b>'+COUNTS[e]+'</b>';box.appendChild(c);
 });
}
function renderEmoChips(popEmo){
 var box=document.getElementById('emoChips');box.innerHTML='';
 Object.keys(EMOS).forEach(function(e){
  var b=document.createElement('button');b.type='button';
  b.innerHTML=EMOS[e]+' '+e+'<span class="ai">\u2728 AI</span>';
  b.className=(e===selEmo?'sel':'')+(e===selEmo&&byAI?' byai':'')+(e===popEmo?' popc':'');
  b.onclick=function(){selEmo=e;byAI=false;manual=true;renderEmoChips();
   document.getElementById('aiHint').innerHTML='You picked <b>'+e+'</b> \u2014 AI will stay quiet now.';};
  box.appendChild(b);
 });
}
(function(){
 try{
  renderCounts();renderEmoChips();
  var ta=document.getElementById('memText'),hint=document.getElementById('aiHint'),t;
  function scan(){
   if(manual)return;
   var v=ta.value.trim();
   if(v.length<8){hint.innerHTML='\u2728 AI will suggest a mood as you write\u2026';return;}
   var d=detectEmo(v);
   if(d){
    var changed=d!==selEmo;
    selEmo=d;byAI=true;renderEmoChips(d);
    hint.innerHTML='\u2728 AI feels this memory is <b>'+d+'</b> \u2014 tap another mood to change.';
    if(!changed){var c=document.querySelector('.emo-chips .sel');if(c){c.classList.remove('popc');void c.offsetWidth;c.classList.add('popc');}}
   }else{
    hint.innerHTML='\u2728 AI is reading\u2026 keep writing, or tap a mood yourself.';
   }
  }
  ['input','keyup','change'].forEach(function(ev){
   ta.addEventListener(ev,function(){clearTimeout(t);t=setTimeout(scan,350);});
  });
 }catch(err){/* fail-safe: chips remain manual */}
})();
function postMemory(){
 var s=document.getElementById('memScent').value,
     t=document.getElementById('memText').value.trim(),
     w=document.getElementById('memWho').value.trim();
 if(!s||!t){alert('Pick a mood and write your memory first.');return;}
 var names={sunflare:'Sunflare',aqualume:'Aqualume',floranta:'Floranta',woodveil:'Woodveil',amorven:'Amorven',dusktime:'Dusktime'};
 var emo=selEmo||detectEmo(t)||'Nostalgia';
 COUNTS[emo]=(COUNTS[emo]||0)+1;renderCounts(emo);
 var card=document.createElement('div');card.className='mem-card';
 card.style.setProperty('--mtint','var(--'+s+')');
 card.innerHTML='<p>\u201C'+t.replace(/</g,'&lt;')+'\u201D</p><span class="scent-tag">'+names[s]+'</span><span class="emo-pill">'+EMOS[emo]+' '+emo+'</span><div class="who">'+(w?w.replace(/</g,'&lt;'):'Anonymous')+' \u00B7 just now \u00B7 \uD83C\uDFC6 entered this month\u2019s contest</div>';
 var wall=document.getElementById('memWall');wall.insertBefore(card,wall.firstElementChild);
 document.getElementById('memText').value='';document.getElementById('memWho').value='';
 document.getElementById('memScent').value='';document.getElementById('memN').textContent='280';
 manual=false;byAI=true;selEmo='Nostalgia';renderEmoChips();
 document.getElementById('aiHint').innerHTML='✨ AI will suggest a mood as you write…';
 card.scrollIntoView({behavior:'smooth',block:'center'});
 /* DEV NOTE: POST entry {text, scent, emotion, contact} to moderation backend */
}


